<section >
  <div class="container-fluid px-2">
      
      <div class="row mt-4">
          <div class="col-12 col-sm-6 col-md-3">
              <div class="card my-card">
               
                <div class="my-auto pl-3">
                  <p class="font-16">Available Amount</p>
                  <h2 class="font-28 l-42 gray-t font600">5000</h2>
                </div>
                <div class="my-auto ml-auto pr-3 mr-3 icon-bg">
                 <i class="trans-icon">&nbsp;</i>
                </div>
                
              </div>
          </div>
          
          <div class="col-12 col-sm-6 col-md-3">
              <div class="card my-card">
               
                  <div class="my-auto pl-3">
                    <p class="font-16">Transfer Amount</p>
                    <h2 class="font-28 l-42 gray-t font600">2000</h2>
                  </div>
                  <div class="my-auto ml-auto pr-3 mr-3 icon-bg pr-3">
                      <i class="approve-icon">&nbsp;</i>
                  </div>
                  
                </div>
          </div>
          
          <div class="col-12 col-sm-6 col-md-3">
              <div class="card my-card">
               
                  <div class="my-auto pl-3">
                    <p class="font-16">Decline Amount</p>
                    <h2 class="font-28 l-42 gray-t font600">502</h2>
                  </div>
                  <div class="my-auto  ml-auto pr-3 mr-3 icon-bg pr-3">
                      <i class="decline-icon">&nbsp;</i>
                  </div>
                  
                </div>
          </div>
          
          <div class="col-12 col-sm-6 col-md-3">
              
              <div class="card my-card">
               
                  <div class="my-auto pl-3">
                    <p class="font-16">Pending Amount</p>
                    <h2 class="font-28 l-42 gray-t font600">400</h2>
                  </div>
                  <div class="my-auto ml-auto pr-3 mr-3  icon-bg pr-3">
                      <i class="submitted-icon">&nbsp;</i>
                  </div>
                  
                </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-xl-12">
             <div class="card-1" id="cardChart4">
               <h4>Line </h4>
                <div class="card-wrapper">
                   <div class="card-body">
                      <div flot [dataset]="lineData" [options]="lineOptions" ></div>
                   </div>
                </div>
             </div>
          </div>
       </div>
      <div class="row mt-5">
        <div class="col-md-12 mt-3">
          
        </div>
    </div>
      </div>
   
</section>